import React from "react";

const Languages = () => {
  return (
    <section id="languages" className="w-full bg-[#0d0d0d] py-20">
      {/* Section header (diğerleriyle uyumlu) */}
      <div className="px-6 md:px-10 mb-12">
        <h2 className="text-5xl md:text-6xl font-semibold tracking-tight text-white/90">
          Languages
        </h2>
      </div>

      {/* Content */}
      <div className="px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
          
          {/* Turkish */}
          <div className="flex flex-col items-start gap-4">
            <div className="text-4xl font-semibold tracking-tight text-neutral-200">
              TR
            </div>

            <p className="text-xl md:text-2xl font-medium text-neutral-300">
              Turkish
            </p>

            <p className="max-w-[42ch] text-[16px] md:text-[17px] leading-relaxed text-neutral-400">
              Native proficiency in written and spoken Turkish.
            </p>
          </div>

          {/* English */}
          <div className="flex flex-col items-start gap-4">
            <div className="text-4xl font-semibold tracking-tight text-neutral-200">
              ENG
            </div>

            <p className="text-xl md:text-2xl font-medium text-neutral-300">
              English
            </p>

            <p className="max-w-[42ch] text-[16px] md:text-[17px] leading-relaxed text-neutral-400">
              Professional working proficiency in English. Comfortable with
              technical documentation and communication.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Languages;
